export interface BatchStatisticsCollectionRequest {
  acceptanceDateFrom: string
  acceptanceDateTo: string
  collectionTitle: string
  registBranchCodeFrom: string
  registBranchCodeTo: string
  collectionType: string
  collectionStatus: string
  removalCollection: string
  preAcceptance: string
  bookbinding: string
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  numberEnabled: boolean
  amountOfMoneyEnabled: boolean
  isOutputFull: boolean
  collectionMemo: string
  batchType: string
}

export function BatchStatisticsCollectionRequestToJSON(
  value: BatchStatisticsCollectionRequest
): any {
  return {
    acceptance_date_from: value.acceptanceDateFrom,
    acceptance_date_to: value.acceptanceDateTo,
    title: value.collectionTitle,
    regist_branch_code_from: value.registBranchCodeFrom,
    regist_branch_code_to: value.registBranchCodeTo,
    collection_type: value.collectionType,
    collection_status: value.collectionStatus,
    removal_collection: value.removalCollection,
    pre_acceptance: value.preAcceptance,
    bookbinding: value.bookbinding,
    x_item: value.xItem,
    y_item1: value.yItem1,
    y_check1: value.yCheck1,
    y_item2: value.yItem2,
    y_check2: value.yCheck2,
    y_item3: value.yItem3,
    y_check3: value.yCheck3,
    y_item4: value.yItem4,
    y_check4: value.yCheck4,
    number_enabled: value.numberEnabled,
    amount_of_money_enabled: value.amountOfMoneyEnabled,
    is_output_full: value.isOutputFull,
    memo: value.collectionMemo,
    batch_type: value.batchType
  }
}
